import { userModel } from "../models";
import { LicenseHelpers } from "./licenseHelpers";

export const UserHelpers = () => {
    const ProcessRawUserData = (userRawData,authTenantId,tenantModel) => {
        try {
            let canUserAccess = false;
            const profile = userRawData.profile;
            const roles = userRawData.roles;
            const status = userRawData.status;

            let userRole = "";
            let filteredRoles = roles.filter(role => role.resourceUuid === authTenantId && (role.resourceId === tenantModel.identifier || role.resourceId === authTenantId));
            let ADMINRole = filteredRoles.find(role => role.appId === "AML");
            if(ADMINRole){
                canUserAccess = true;
                userRole = ADMINRole.actionKey;
            } else {
                let OWNERRole = filteredRoles.find(role => role.actionKey === "OWNER" && role.appId === null);
                if(OWNERRole){
                    canUserAccess = true;
                    userRole = OWNERRole.actionKey;
                }
            }
            let user = new userModel(
                profile.tsUserCode,
                authTenantId,
                profile.id,
                profile.email,
                profile.firstName || "",
                profile.lastName || "",
                (profile.firstName + " " + profile.lastName) || "",
                userRole,
                profile.language || "it-IT",
                1,
                false,
                "Commercialista",
                status.active,
                status.deleted,
                status.banned,
                new Date(),
                null,
                "",
                false,
                "",
                "",
                "",           
                "",
                profile.tsid
            )              
            return { 
                userNew : user, 
                elaboratedAccess : canUserAccess                
            };
        } catch (error) {
                throw new Error("Errore durante l'elaborazione dei dati dell'utente: " + error.message);
        }
    }

    return {
        ProcessRawUserData
    }
}